module.exports = __webpack_public_path__ + "assets/img/A-af450a92.jpg";